import { Susp } from '../lib/Susp';
import { trpc } from '../lib/trpc';
import { List } from './List';
import { Singleton } from './Singleton';
import { Button } from '@mantine/core';
import { use, useEffect } from 'react';
import { Link, useLocation, useParams } from 'wouter';

export const Content = () => {
  const { modelId } = useParams();
  const [, navigate] = useLocation();

  const models = use(
    trpc.models.list.useQuery(undefined, {
      experimental_prefetchInRender: true,
    }).promise,
  );

  useEffect(() => {
    if (models && !modelId && models[0]) {
      navigate(`/content/${models[0].models.id}`, {
        replace: true,
      });
    }
  }, [modelId, models, navigate]);

  let mainContent;
  if (modelId) {
    const model = models?.find((ct) => ct.models.id === modelId);
    if (model?.models.type === 'singleton') {
      // mainContent = (
      //   <>
      //     <Title order={3}>{model?.name}</Title>
      //     {JSON.stringify(model)}
      //   </>
      // );
      mainContent = <Singleton params={model} />;
    } else {
      mainContent = <List modelId={modelId} />;
    }
  }

  return (
    <div className="w-full grow flex flex-row">
      <div className="min-w-52 border-r border-r-slate-300 flex flex-col p-5">
        {models?.map((type) => (
          <Button
            classNames={{ inner: 'justify-start' }}
            component={Link}
            key={type.models.id}
            to={`/content/${type.models.id}`}
            variant={modelId === type.models.id ? 'light' : 'transparent'}
          >
            {type.models.name}
          </Button>
        ))}
      </div>
      <div className="p-5 grow">
        <Susp>{mainContent}</Susp>
      </div>
    </div>
  );
};
